'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getWaveform();
  }

  getWaveform() {
    this.$http.get(`/api/waveforms/${this.$stateParams.id}`).then(res => {
      this.waveform = res.data;
    });
  }

  save() {
    this.$http.put(`/api/waveforms/${this.$stateParams.id}`, this.waveform).then(res => {
      this.$state.go('^');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/waveforms/edit/edit.controller.js